__turbopack_context__.v({
  "carouselWrapper": "LeftPanelComponent-module__5pDAHW__carouselWrapper",
  "h2": "LeftPanelComponent-module__5pDAHW__h2",
  "headerInfoMobile": "LeftPanelComponent-module__5pDAHW__headerInfoMobile",
  "mblPriceContainer": "LeftPanelComponent-module__5pDAHW__mblPriceContainer",
  "titleContainer": "LeftPanelComponent-module__5pDAHW__titleContainer",
});
